<template><!-- svgo-optimised -->
<svg class="icon icon__Plus icon__plus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 11.5h6v1h-6v6h-1v-6h-6v-1h6v-6h1v6Z"/></svg></template>